import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "m-bottom-25" }, "Reset your Password", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Forgot your password? No worries.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Just Enter the email you used to sign up and we’ll send you a link to reset it", -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Need a IMDatacenter account? ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Create an account")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_base_input, {
      class: "m-top-32",
      title: "Email",
      placeholder: "grace.soto@example.com",
      bind: { autocomplete: 'email' },
      value: _ctx.form.email,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
    }, null, 8, ["value"]),
    _createElementVNode("button", {
      class: "btn fill m-top-32 t-t-u m-bottom-16",
      disabled: _ctx.loader,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)))
    }, "Send me email", 8, _hoisted_4),
    _createElementVNode("p", null, [
      _hoisted_5,
      _createVNode(_component_router_link, { to: "sign-up" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ], 64))
}